<proffeo-ui-dialog [title]="'project-industries.modals.select-admin-modal-title' | translate">
  <div class="flex flex-col w-full h-full gap-2">
    @if (companyUsers()?.length) {
      <proffeo-select-user-list
        [(selectedUser)]="selectedUser"
        [preselectedUserId]="preselectedUser()"
        [originalUsers]="companyUsers()"
      ></proffeo-select-user-list>
    }
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
